"use client";
import {useRoutePlan} from "@/context/routePlan/optimizer/routePlanVariant";
import {useEffect} from "react";
import {HitoryRoutePlan} from "./leftWidgets/leftHistory";
import {LeftRoutePlan} from "./leftWidgets/leftRoutePlan";
export const RoutesLeftBar = function ({
  setIsHistoryTab,
  isHistoryTab
}: {
  setIsHistoryTab: (val: boolean) => void;
  isHistoryTab: boolean;
}) {
  const {routePlanItem} = useRoutePlan();
  useEffect(() => {
    if (routePlanItem) {
      // 1 - Pending 2 - processing , 4 - Failed
      if (
        routePlanItem.status === 1 ||
        routePlanItem.status === 2 ||
        routePlanItem.status === 4
      ) {
        setIsHistoryTab(false);
      }
    }
  }, [routePlanItem]);
  return (
    <>
      {isHistoryTab ? (
        <HitoryRoutePlan setIsHistoryTab={setIsHistoryTab} />
      ) : (
        <LeftRoutePlan setIsHistoryTab={setIsHistoryTab} />
      )}
    </>
  );
};
